import {
  Box,
  Checkbox,
  Icon,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CoreTypographyBody1 from "../CoreTypographyBody1";
import { CoreDataTableToolbar } from "./CoreDataTableToolbar";
import { theme } from "../../../config/theme";
import CorePopOver from "../../layouts/CorePopOver";
import ActionPopOver from "./ActionPopOver";
import EditableCell from "./EditableCell";
import { api_request } from "../../../store/actions/commonAction";
import {
  TABLE_DATA_LOADING,
  TABLE_DATA_RESET,
} from "../../../store/types/dtType";
import { Formik } from "formik";
import { fieldEditSchema } from "../../../formSchemas/docSchemas";

export default function CoreDataTable(props) {
  const {
    tableId = "datatable",
    size = "small",
    ariaLable = "a dense table",
    columns,
    actions,
    rowActions,
    containerStyle = { marginTop: 1 },
    showToolbar = true,
    noOfRows = 10,
    dense = false,
    pagination = true,
    elevation = true,
    selectable = true,
    editable = false,
    onSave,
    searchable = false,
    apiDetails = null,
    userFilter = null,
    dataRows = null,
    onChangeHook = null,
    inputTypeMap = null,
    inputValMap = null,
    noUserFilter = false,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(noOfRows);
  const [hoveredElement, setHoveredelement] = useState(null);
  const [selections, setSelections] = useState([]);
  const [allSelected, setSelectAll] = useState(false);
  const [editData, setEditable] = useState({});
  const [value, setValue] = useState({});
  const [editCol, setEditCol] = useState(null);
  const [searchStr, setSearchStr] = useState("");
  const dispatch = useDispatch();
  const data = useSelector((state) => state.dt[tableId]);
  const rows = !apiDetails ? dataRows : data?.rows;
  const totalRecords = !apiDetails ? rows?.length : data?.totalRecords;
  const loading = data?.loading;

  const userSettings = useSelector((state) => state?.common?.userSettings);
  const dangerousCharAllowed = userSettings?.find(
    (set) => set.name === "dangerous-char-allowed",
  )
    ? userSettings?.find((set) => set.name === "dangerous-char-allowed")?.value
        ?.enabled
    : false;

  useEffect(() => {
    if (apiDetails && (noUserFilter || userFilter)) {
      console.warn("user filter change");
      getData(page, rowsPerPage, true);
    }
  }, [userFilter]);

  useEffect(() => {
    return () => {
      dispatch({ type: TABLE_DATA_RESET, id: tableId });
    };
  }, []);

  useEffect(() => {
    setSelections([]);
    setSelectAll(false);
  }, [rows]);

  const getData = (pageNo, noOfEntry, init = false, searchText = null) => {
    console.log("search text", searchText);
    dispatch(
      api_request(
        apiDetails.method,
        apiDetails.path,
        {},
        searchText
          ? {
              _defaultFilter: encodeURIComponent(
                JSON.stringify(
                  searchText
                    ? {
                        ...(userFilter || {}),
                        ["$" + apiDetails.searchKey + "$"]: {
                          iLike: "%" + searchText + "%",
                        },
                      }
                    : {
                        ...(userFilter || {}),
                      },
                ),
              ),
            }
          : {
              _defaultFilter: encodeURIComponent(
                JSON.stringify({
                  ...(userFilter || {}),
                }),
              ),
              offset: pageNo * noOfEntry,
              limit: noOfEntry * 2,
            },
        "dt#" + tableId,
        [apiDetails.successType, "dt#" + tableId],
        [apiDetails.errorType, "dt#" + tableId],
        apiDetails.authorized,
        false,
        false,
      ),
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (apiDetails) {
      getData(newPage, rowsPerPage);
    }
  };

  const handlePopoverOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setHoveredelement(row);
  };

  const handlePopoverClose = (e) => {
    console.log("release ", e.currentTarget);
    setAnchorEl(null);
    setHoveredelement(null);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event?.target?.value, 10));
    setPage(0);
    if (apiDetails) {
      getData(0, parseInt(event?.target?.value, 10));
    }
  };

  const changeSelctions = (row) => {
    let idList = [...(selections || [])];
    if (selections?.includes(row.id)) {
      idList = idList.filter((id) => id !== row.id);
    } else {
      idList.push(row.id);
    }
    setSelections(idList);
  };

  const changeAllSelctions = () => {
    if (!allSelected)
      setSelections(
        visibleRows?.map((row) => {
          return row.id;
        }),
      );
    else {
      setSelections([]);
    }
    setSelectAll(!allSelected);
  };

  const setEditMode = (id, val, row, col) => {
    console.log("edit called", id, val, row, col);
    setAnchorEl(null);
    let newId = null;
    if (typeof id === "function") {
      console.log(id(row));

      newId = id(row);
    } else {
      newId = id;
    }
    let newEditData = { ...editData, [String(newId)]: true };
    let newValue = { ...value, [String(newId)]: val };
    setEditable(newEditData);
    setValue(newValue);
    if (onChangeHook) {
      onChangeHook(newEditData, newValue);
    }
  };

  const changeHandler = (val, id) => {
    let newVal = { ...value, [String(id)]: val };
    setValue(newVal);

    if (onChangeHook) {
      onChangeHook(editData, newVal);
    }
  };

  const onCancel = (e) => {
    const id = e.target.id.replace("cancel-", "").replace("cancelicon-", "");
    console.log("cancel", e.target);

    let newVal = { ...value, [String(id)]: "" };
    let newEditData = { ...editData, [String(id)]: false };
    setEditable(newEditData);
    setValue(newVal);
    if (onChangeHook) {
      onChangeHook(newEditData, newVal);
    }
  };

  let table_columns = columns
    ? columns?.map((col) => {
        return {
          ...col,
          name: col.name || col.label,
          key: col.key || col.name || col.label,
        };
      })
    : rows?.length > 0
      ? Object.keys(rows[0]).map((col) => {
          return { label: col, name: col, key: col };
        })
      : [];

  const visibleRows = React.useMemo(() => {
    return rows?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [page, rowsPerPage, rows, table_columns]);

  // console.log("ROWS", editData, value, inputTypeMap, inputValMap);

  return table_columns ? (
    <Box sx={containerStyle}>
      {showToolbar && (
        <CoreDataTableToolbar
          rowActions={rowActions}
          actions={actions}
          selections={selections}
          searchable={searchable}
          searchStr={searchStr}
          onSearchChange={(e) => {
            setSearchStr(e?.target?.value);
          }}
          getData={{ func: getData, page, rowsPerPage }}
        />
      )}
      {!(Object.values(editData).filter((trueVal) => trueVal).length > 0) &
      (rowActions?.length > 0) ? (
        <ActionPopOver
          rowActions={rowActions}
          handlePopoverClose={handlePopoverClose}
          handlePopoverOpen={handlePopoverOpen}
          anchorEl={anchorEl}
        >
          {rowActions?.map((action, i) => (
            <IconButton
              key={"datatable-action-" + hoveredElement?.id + "-" + i}
              style={i > 0 ? { marginLeft: 8 } : {}}
              disableFocusRipple={true}
              id="datatable-action"
              size="small"
              onClick={() => {
                action.onClick(hoveredElement);
              }}
            >
              {action.title ? (
                <Tooltip title={action.title}>
                  <Icon
                    id="datatable-action"
                    style={action.style || { fontSize: 22 }}
                  >
                    {action.icon}
                  </Icon>
                </Tooltip>
              ) : (
                <Icon
                  id="datatable-action"
                  style={action.style || { fontSize: 22 }}
                >
                  {action.icon}
                </Icon>
              )}
            </IconButton>
          ))}
        </ActionPopOver>
      ) : null}
      <TableContainer width={"100%"} component={elevation ? Paper : Box}>
        <Table width={"100%"} size={size} aria-label={ariaLable}>
          <TableHead>
            <TableRow>
              {selectable ? (
                <TableCell padding="checkbox" style={{ width: "1%" }}>
                  {visibleRows?.length > 0 && (
                    <Checkbox
                      color="primary"
                      checked={allSelected}
                      onChange={changeAllSelctions}
                      inputProps={
                        {
                          // 'aria-labelledby': labelId,
                        }
                      }
                    />
                  )}
                </TableCell>
              ) : null}
              {table_columns?.map((d, key) => (
                <TableCell
                  padding={dense ? "none" : "normal"}
                  sx={{
                    minWidth: d.width ? d.width : "150px",
                    maxWidth: d.width ? d.width : "150px",
                    width: d.width ? d.width : "150px",
                  }}
                  key={d.key || key}
                  style={
                    d.name === editCol || d.label === editCol
                      ? { minWidth: 200, paddingLeft: "8px" }
                      : { paddingLeft: "8px" }
                  }
                >
                  {d.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows?.length < 1 ? (
              <TableRow>
                <TableCell colSpan={table_columns?.length}>
                  <Box style={{ display: "flex", justifyContent: "center" }}>
                    {loading ? "Loading..." : "No data found"}
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              visibleRows?.map((row, keyR) => (
                <TableRow
                  key={row.id}
                  aria-owns={anchorEl ? "mouse-over-popover" : undefined}
                  aria-haspopup="true"
                  onMouseEnter={(e) => {
                    handlePopoverOpen(e, row);
                  }}
                  checked={selections?.includes(row.id)}
                  style={{ minHeight: 30 }}
                >
                  {selectable ? (
                    <TableCell padding="checkbox" style={{ width: "1%" }}>
                      <Checkbox
                        color="primary"
                        checked={selections?.includes(row.id)}
                        onChange={(e) => {
                          changeSelctions(row);
                        }}
                        inputProps={
                          {
                            // 'aria-labelledby': labelId,
                          }
                        }
                      />
                    </TableCell>
                  ) : null}
                  {table_columns?.map((col, ind) => (
                    <TableCell
                      title={String(col.view ? col.view(row) : row[col.name])}
                      padding={dense ? "none" : "normal"}
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        minWidth: col.width ? col.width : "150px",
                        maxWidth: col.width ? col.width : "150px",
                        width: col.width ? col.width : "150px",
                        paddingLeft: "8px",
                        paddingRight: dense
                          ? "8px"
                          : ind < table_columns.length - 1
                            ? 0
                            : "8px",
                        textAlign: isNaN(
                          col.view ? col.view(row) : row[col.name],
                        )
                          ? "left"
                          : "right",
                      }}
                      key={`${col.name}-${row.id}`}
                      style={
                        col.name === editCol || col.label === editCol
                          ? { minWidth: 200 }
                          : {}
                      }
                    >
                      <Formik
                        initialValues={
                          typeof col.id === "function"
                            ? {
                                [col.id(row)]: value?.[col.id(row)],
                              }
                            : {
                                [col.id]: value?.[col.id],
                              }
                        }
                        validationSchema={fieldEditSchema(
                          typeof col.id === "function" ? col.id(row) : col.id,
                          dangerousCharAllowed,
                        )}
                        onSubmit={(values, actions) => {
                          if (typeof col.id === "function")
                            onSave(col.id(row), values[col.id(row)]);
                          else {
                            onSave(col.id, values[col.id]);
                          }
                          onCancel();
                        }}
                        enableReinitialize
                      >
                        {(formikProps) => (
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                              width: "100%",
                            }}
                          >
                            <Box
                              style={{
                                display: "flex",
                                alignItems: "center",
                                height: "100%",
                                width: "100%",
                                minHeight: 10,
                                minWidth: 10,
                              }}
                              onClick={() => {
                                if (
                                  editable &&
                                  !editData?.[
                                    String(
                                      typeof col.id === "function"
                                        ? col.id(row)
                                        : col.id,
                                    )
                                  ]
                                ) {
                                  setEditMode(
                                    col.id,
                                    col.view ? col.view(row) : row[col.id],
                                    row,
                                    col.name || col.label,
                                  );
                                }
                              }}
                            >
                              <EditableCell
                                editData={editData}
                                col={col}
                                onEdit={changeHandler}
                                onCancel={onCancel}
                                onSave={onSave}
                                row={row}
                                formikProps={formikProps}
                                inputTypeMap={inputTypeMap}
                                inputValMap={inputValMap}
                              />
                            </Box>

                            {(typeof col.id === "function" &&
                              editData[col.id(row)]) ||
                            editData[col.id] ? (
                              <Box
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: 8,
                                }}
                              >
                                <IconButton
                                  size="small"
                                  id={`save-${
                                    typeof col.id === "function"
                                      ? col.id(row)
                                      : col.id
                                  }`}
                                  onClick={formikProps.handleSubmit}
                                >
                                  <Icon
                                    id={`save-${
                                      typeof col.id === "function"
                                        ? col.id(row)
                                        : col.id
                                    }`}
                                    style={{ fontSize: 22 }}
                                  >
                                    save
                                  </Icon>
                                </IconButton>
                                <IconButton
                                  id={`cancel-${
                                    typeof col.id === "function"
                                      ? col.id(row)
                                      : col.id
                                  }`}
                                  size="small"
                                  onClick={onCancel}
                                >
                                  <Icon
                                    id={`cancelicon-${
                                      typeof col.id === "function"
                                        ? col.id(row)
                                        : col.id
                                    }`}
                                    style={{ fontSize: 22 }}
                                  >
                                    cancel
                                  </Icon>
                                </IconButton>
                              </Box>
                            ) : null}
                          </Box>
                        )}
                      </Formik>
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          component="div"
          style={{ backgroundColor: theme.palette.background.paper }}
          count={totalRecords}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </Box>
  ) : (
    <CoreTypographyBody1>No data</CoreTypographyBody1>
  );
}
